import React from 'react';
import { OnboardingData, CustomerProgress } from '../../types';
import QuickStats from './QuickStats';
import HealthScoreCard from './HealthScoreCard';
import CompanyGoal from './CompanyGoal';
import SignupInfo from './SignupInfo';
import ProgressBar from './ProgressBar';
import TaskList from './TaskList';
import ProgressMilestones from './ProgressMilestones';
import './OnboardingWidget.css';

interface OnboardingWidgetViewProps {
  onboardingData: OnboardingData;
  progressPercentage: number;
  completedTasksCount: number;
  taskStats: {
    required: number;
    recommended: number;
    optional: number;
    total: number;
  };
  milestoneReached: {
    twentyFive: boolean;
    fifty: boolean;
    seventyFive: boolean;
    hundred: boolean;
  };
  updating: boolean;
  onTaskStatusChange: (taskId: string, status: CustomerProgress['status']) => void;
}

const OnboardingWidgetView: React.FC<OnboardingWidgetViewProps> = React.memo(({
  onboardingData,
  progressPercentage,
  completedTasksCount,
  taskStats,
  milestoneReached,
  updating,
  onTaskStatusChange,
}) => {
  return (
    <div className={`onboarding-widget-modern ${updating ? 'updating' : ''}`}>
      <QuickStats 
        customer={onboardingData.customer}
        tasks={onboardingData.tasks}
        progress={onboardingData.progress}
        healthScore={onboardingData.healthScore}
        completedCount={completedTasksCount}
        totalCount={taskStats.total}
      />

      <div className="widget-content-grid">
        <div className="main-content">
          <SignupInfo 
            customer={onboardingData.customer} 
            progress={progressPercentage}
          />
          
          <div className="progress-section card">
            <h3 className="section-title">Onboarding Progress</h3>
            <ProgressBar 
              percentage={progressPercentage}
              label=""
            />
            <ProgressMilestones milestoneReached={milestoneReached} />
          </div>

          <CompanyGoal customer={onboardingData.customer} />
          
          <div className="tasks-section card">
            <h3 className="section-title">Your Tasks</h3>
            <TaskList
              tasks={onboardingData.tasks}
              progress={onboardingData.progress}
              onTaskStatusChange={onTaskStatusChange}
            />
          </div>
        </div>

        <div className="sidebar-content">
          <HealthScoreCard healthScore={onboardingData.healthScore} />
        </div>
      </div>
    </div>
  );
});

OnboardingWidgetView.displayName = 'OnboardingWidgetView';

export default OnboardingWidgetView;